/* eslint-disable import/prefer-default-export */
export class ParamsUtil {
  static addParams(url, params) {
    if (!url) {
      return url;
    }
    let newUrl = url;
    const questionMarkIndex = newUrl.indexOf('?');
    const questionMark = newUrl.split('').filter((v) => v === '?').length;
    const hashIndex = newUrl.indexOf('#');
    const str = Object.keys(params)
      .reduce((res, cur) => {
        if (params[cur] === undefined || params[cur] === null) {
          return res;
        }
        return `${res}&${cur}=${encodeURIComponent(params[cur])}`;
      }, '')
      .slice(1);

    if (questionMarkIndex > hashIndex || questionMark === 2) {
      // 已经有query并且属于hash中的, 或者仅有query
      newUrl = `${newUrl}&${str}`;
    } else {
      newUrl = `${newUrl}?${str}`;
    }

    return newUrl;
  }

  static noEncodeAddParams(url, params) {
    if (!url) {
      return url;
    }
    let newUrl = url;
    const questionMarkIndex = newUrl.indexOf('?');
    const questionMark = newUrl.split('').filter((v) => v === '?').length;
    const hashIndex = newUrl.indexOf('#');
    const str = Object.keys(params)
      .reduce((res, cur) => {
        if (params[cur] === undefined || params[cur] === null) {
          return res;
        }
        return `${res}&${cur}=${(params[cur])}`;
      }, '')
      .slice(1);

    if (questionMarkIndex > hashIndex || questionMark === 2) {
      // 已经有query并且属于hash中的, 或者仅有query
      newUrl = `${newUrl}&${str}`;
    } else {
      newUrl = `${newUrl}?${str}`;
    }

    return newUrl;
  }

  static getParam(keyName, url) {
    const urlStr = url || window.location.href;
    // eslint-disable-next-line
    const name = keyName.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(urlStr);
    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  static getParams(url = window.location.href) {
    const params = {};
    const search = url.split('?')[1];
    if (search) {
      const parts = search.split('&');
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < parts.length; i++) {
        const nv = parts[i].split('=');
        if (nv[0]) {
          params[nv[0]] = nv[1] || true;
        }
      }
    }
    return params;
  }

  static removeParams(url, key) {
    // eslint-disable-next-line
    const name = key.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${name}(=([^&#]*(&|#|$))|&|#|$)`);
    return url.replace(regex, (item) => {
      if (/^\?/.test(item)) {
        return '?';
      }
      if (/^&.+&$/.test(item)) {
        return '&';
      }
      if (/#$/.test(item)) {
        return '#';
      }
      return '';
    });
  }
}
